import React, { useEffect, useState, useRef } from 'react';
import './index.scss';
import Form, {Label, SimpleItem,RequiredRule, GroupItem} from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';
import FileUploader from 'devextreme-react/file-uploader';
import userApi from '../../../../api/user';
import addressApi from '../../../../api/address';
import profileApi from '../../../../api/user';
import StatesService from '../../../../utils/states';
import CountryService from '../../../../utils/country';
import DataSource from 'devextreme/data/data_source';
import url from '../../../../api/base-url';
import notify from 'devextreme/ui/notify';
import sessions from '../../../../sessions';

const MyProfile = () => {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [countryValue, setCountryValue] = useState('');
    const [profile, setProfile] = useState();
    const [showRemoveBtn, setShowRemoveBtn] = useState(false);
    const [isPreviewImage, setIsPreviewImage] = useState(false);
    const [filePath, setFilePath] = useState('');
    const [addressId, setAddressId] = useState();
    const defaultAvatar = "https://www.dropbox.com/s/lve7qp6ro3kda0x/male_avatar.png";
    const uservatar = sessions.getSession("user");
    const avatar = Object.entries(uservatar.avatarUrl).length===0?defaultAvatar:uservatar.avatarUrl.toString().split('?')[0];
    useEffect(() => {
        (async()=>{
            const userData =  await userApi.getUserById(userId).then(result => {
                return result.data.data;
            })
            const addressData = await addressApi.getMainAddress(userId).then(result => {
                //console.log("rsss",result)
                return result.data.data;
            });
            setProfile({...userData,...addressData});
            setAddressId(addressData?._id);
          })()
    }, [userId]);

    const onUploaded = (e) => {
        let response = JSON.parse(e.request.response)
        let imageURL = response.data.path.replace('output/', '')
        setFilePath(imageURL)
        setShowRemoveBtn(true)
        setIsPreviewImage(true)
    }

    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'iso2'
        },
        pageSize: 10,
        paginate: true
    });

    const CountryOnChange = ({ value }) => {
        setCountryValue(value)
        console.log('countryValue', value);
    }

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'name'
        },
        filter: [
            "country_code", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });    
 

    const submitBtn = () => {
        let dataSend = {
            username: profile.username,
            firstname: profile.firstname,
            email: profile.email,
            lastname: profile.lastname,
            avatarUrl: filePath,
            addressId:addressId,
            country: profile.country,
            state: profile.state,
            city:profile.city,
            street1:profile.street1,
            zipCode:profile.zipCode
        }
        profileApi.updateUser(userId, dataSend,auth)
            .then((res) => {
                console.log("profile",res);
                if(res.status === 200) {
                    if(filePath){
                        window.location.reload();
                    }
                    notify("update succesfully", "success", 500);
                } else {
                    notify("Something is wrong", "warning", 500);
                }
            })
            
    }

    const removeImageBtn = () => {
        setFilePath('')
        setIsPreviewImage(false)
        setShowRemoveBtn(false)
    }     

    return (
        <React.Fragment>
             <div>
                <h4 className={'content-block'}>My Profile</h4>
            </div>
            <div className={'content-block'}>
            <form id={'my-profile-form'}>
                <Form formData={profile}>
                <GroupItem cssClass="first-group" colCount={4}>
                <SimpleItem width={400}>
                    <div className={'form-avatar'}>
                    {
                        (isPreviewImage) ?
                        <img alt={'user avatar'} src={`${url}/${filePath}`} className={'avatar'} /> :
                        <img alt={'default avatar'} src={`${avatar}?raw=1`} className={'avatar'} />
                    }                                                   
                    </div>
                    <div className={'fileuploader-container'}>
                        <FileUploader 
                            selectButtonText="Select Photo" 
                            width = {200}
                            labelText="" 
                            name="files"
                            accept="image/*" 
                            uploadUrl={`${url}/upload`} 
                            onUploaded={onUploaded}
                            />
                        <Button 
                            width={120}
                            disabled={!showRemoveBtn}
                            style={{ 
                                display: showRemoveBtn ? "block" : "none", 
                                backgroundColor: 'red', 
                                color: 'white' ,
                                marginBottom: '65px'
                                }} 
                            onClick={removeImageBtn} text="Remove"  
                        />
                        </div>
                </SimpleItem>
                <GroupItem colSpan={3} colCount={2}>
                    <SimpleItem dataField="firstname" editorOptions={{ stylingMode:'filled',height: 40}}>
                        <Label text={'First Name'}/>
                    </SimpleItem>
                    <SimpleItem dataField="lastname" editorOptions={{ stylingMode:'filled',height: 40}}>
                        <Label text={'Last Name'}/>
                    </SimpleItem>
                    <SimpleItem dataField="email" editorOptions={{ stylingMode:'filled',height: 40}}/>
                    <SimpleItem dataField="phone" editorOptions={{ stylingMode:'filled',height: 40}}/>
                </GroupItem>
                </GroupItem>
                <GroupItem cssClass="second-group" colCount={3}>
                    <SimpleItem
                        editorType={'dxSelectBox'}
                        dataField="country"
                        editorOptions={{
                        dataSource: country,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'iso2',
                        onValueChanged: CountryOnChange,
                        stylingMode:'filled',
                        height: 40
                    }}>
                        <RequiredRule message="country is required"/>
                    </SimpleItem>
                    <SimpleItem
                        dataField="state"
                        editorType="dxSelectBox"
                        editorOptions={{
                        dataSource: state,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        stylingMode:'filled',
                        height: 40
                    }}>
                        <RequiredRule message="state is required"/>
                    </SimpleItem>
                    <SimpleItem dataField="city" editorOptions={{ stylingMode:'filled',height: 40}}/>
                    <SimpleItem dataField="street1" colSpan={2} editorOptions={{ stylingMode:'filled', height: 40}}>
                        <Label text={'Main Address'}/>
                    </SimpleItem>
                    <SimpleItem dataField="zipCode" editorOptions={{ stylingMode:'filled',height: 40}}/>
                </GroupItem>
                <SimpleItem 
                    editorType="dxButton"
                    editorOptions={{
                        text:"Update Profile",
                        type:"default",
                        stylingMode:"contained",
                        onClick:submitBtn,
                        horizontalAlignment: 'right'                           
                }} />
            </Form>
            </form>               
        </div>                                
        </React.Fragment>
    );
};

const colCountByScreen = {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1
};

export default MyProfile;